export const deleteAnswer = (payload: any) => ({
    type: "@saga/DELETE_ANSWER",
    payload
});

